// StarRating.tsx
import React from "react";
import styles from "./StarRating.module.css";

interface StarRatingProps {
    score: number;
}

const StarRating: React.FC<StarRatingProps> = ({ score }) => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
        // Calculate fill percentage (clamped between 0 and 100)
        const fillPercentage = Math.max(0, Math.min(1, score - i)) * 100;
        stars.push(
            <div key={i} className={styles.star}>
                {/* Background star */}
                <span className={styles.starBackground}>★</span>
                {/* Foreground star clipped to fillPercentage */}
                <span
                    className={styles.starForeground}
                    style={{
                        width: `${fillPercentage}%`
                    }}
                >
                    ★
                </span>
            </div>
        );
    }
    return <div className={styles.stars} data-copy-skip="true">{stars}</div>;
};

export default StarRating;
